import { TOptions } from "i18next";

import type { EnGBMessages } from "../locales/en-GB";

export type Leaves<T> = T extends object
  ? {
      [K in keyof T]: `${Exclude<K, symbol>}${Leaves<T[K]> extends never ? "" : `.${Leaves<T[K]>}`}`;
    }[keyof T]
  : never;

export type MessageKey = Leaves<EnGBMessages>;

export type ExtractBases<K extends string, Opt extends string> = K extends `${infer P}.${Opt}`
  ? P
  : never;

export type MissingOptions<P extends string, K extends string, Opt extends string> = Opt extends any
  ? `${P}.${Opt}` extends K
    ? never
    : Opt
  : never;

export type BasesHavingAll<K extends string, Opt extends string> = {
  [P in ExtractBases<K, Opt>]: MissingOptions<P, K, Opt> extends never ? P : never;
}[ExtractBases<K, Opt>];

export type TranslateFunction = (key: MessageKey, options?: TOptions) => string;
export const LanguageValues = [
  "en-US",
  "en-GB",
  "de-DE",
  "el-GR",
  "es-ES",
  "es-MX",
  "et-EE",
  "fr-FR",
  "hi-IN",
  "hr-HR",
  "hy-AM",
  "it-IT",
  "ja-JP",
  "ka-GE",
  "ko-KR",
  "lt-LT",
  "lv-LV",
  "pl-PL",
  "pt-PT",
  "ru-RU",
  "uk-UA",
  "zh-CN",
] as const;

export type Language = (typeof LanguageValues)[number];

export const isLanguage = (value: string): value is Language => {
  return LanguageValues.includes(value as Language);
};
